import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import config from "../../../../config/config";
import moment from "moment";
import { snackActions } from '../../../sc-utilities/SnackBar';
import * as actionDownload from '../../../sc-downloadAll/store/downloadActions';
import { downloadFile } from '../../../sc-utilities';
import { socket } from '../../../../index';
import { download } from '../../../sc-utilities/download.utils';
import * as snackbarActions from '../../../sc-utilities/snackbar/store/snackbarActions';
import {WATCH}  from "../../../sc-utilities/snackbar/store/actionTypes";
import snackbarStore from "../../../../snackbarStore";

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'products/watchProduct',
    pluginName: 'PRODUCT',
    entityName: 'WATCH_PRODUCT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    lazyLoad: true

});

export const downloadReport = (params) => {
    return async _dispatch => {
        const IDs = params.WatchProductIDs;
        const ErasureReportType = params.ErasureReportType;
        try {
            snackbarStore.dispatch(snackbarActions.showType({type: WATCH, selectedNumber: IDs.length}));
            let token = localStorage.getItem('SESSION');

            for (const productID of IDs) {

                const objectURL = `${config.backend_domain}:${config.backend_port}/report/download?ProductID=${productID}&ErasureReportType=${ErasureReportType}&ActiveCustomerID=${params.ActiveCustomerID}&Token=${token}`;

                let filename = `securaze_report.pdf`;

                let response = await fetch(objectURL, { method: 'GET', headers: { 'Content-Type': 'application/pdf' } });
                if (response.status === 200) {
                    const contentDisposition = response.headers.get('Content-Disposition').split(';');
                    for (const item of contentDisposition) {
                        if (item.includes('filename')) {
                            filename = item.split('=')[1];
                        }
                    }
                    let blob = await response.blob();

                    // Create blob link to download
                    const url = window.URL.createObjectURL(
                        new Blob([blob]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        filename,
                    );

                    // Append to html link element page
                    document.body.appendChild(link);

                    // Start download
                    link.click();

                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                } else {
                    snackActions.snackBar({
                        message: `File not found for one of selected files (${productID}).`,
                        options: {
                            variant: 'error'
                        }
                    });
                }
                snackbarStore.dispatch(snackbarActions.incrementCounter(WATCH));
            }
        } catch (error) {
            console.log(error);
            snackActions.snackBar({
                message: `File not found.`,
                options: {
                    variant: 'error'
                }
            });
        }
        snackbarStore.dispatch(snackbarActions.resetSnackbarCounter(WATCH))
    }
}

// Fetch watch products action creators
export const fetchWatchProductInit = () => {
    return crudActions.fetchInit();
};
export const fetchWatchProductStart = () => {
    return crudActions.fetchStart();
};
export const fetchWatchProductSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchWatchProductFail = () => {
    return crudActions.fetchFail();
};

export const fetchWatchProductCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        // dispatch(fetchWatchProductInit());
        try {
            let countRes = await rest.post("/products/watchProduct/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    // dispatch(fetchWatchProductSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchWatchProductFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch watch product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            // dispatch(fetchWatchProductFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch watch product."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchWatchProduct = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        // dispatch(fetchWatchProductInit());
        try {
            let listRes = await rest.post("/products/watchProduct/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                // dispatch(fetchWatchProductSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data.products
            }
            // dispatch(fetchWatchProductFail());
            return []

        } catch (error) {
            // dispatch(fetchWatchProductFail());
            return []
        }
    }
}

// Load watch product action creators
export const loadWatchProductInit = () => {
    return crudActions.loadInit();
};
export const loadWatchProductStart = () => {
    return crudActions.loadStart();
};
export const loadWatchProductSuccess = loadedWatchProduct => {
    return crudActions.loadSuccess(loadedWatchProduct);
};
export const loadWatchProductFail = error => {
    return crudActions.loadFail(error);
};

export const loadWatchProduct = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(loadWatchProductStart());
        try {
            let res = await rest.post('products/watchProduct/load', params);
            if (res.data && res.data.succeeded) {
                dispatch(loadWatchProductSuccess(res.data.result.data ?? false));
                return res.data.result.data;
            }
            dispatch(loadWatchProductFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot load watch product."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot load watch product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(loadWatchProductFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Create watch product action creators
export const createWatchProductInit = () => {
    return crudActions.createInit();
};
export const createWatchProductStart = () => {
    return crudActions.createStart();
};
export const createWatchProductSuccess = createdWatchProduct => {
    return crudActions.createSuccess(createdWatchProduct);
};
export const createWatchProductFail = error => {
    return crudActions.createFail(error);
};
export const createWatchProduct = watchProduct => {
    return async dispatch => {
        await crudActions.create(dispatch, watchProduct);
    };
};

// Edit watch product action creators
export const editWatchProductInit = () => {
    return crudActions.editInit();
};
export const editWatchProductStart = () => {
    return crudActions.editStart();
};
export const editWatchProductSuccess = editedWatchProduct => {
    return crudActions.editSuccess(editedWatchProduct);
};
export const editWatchProductFail = error => {
    return crudActions.editFail(error);
};
export const editWatchProduct = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editWatchProductStart());
        try {
            let res = await rest.post('products/watchProduct/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated watch product.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editWatchProductFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit watch product."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit watch product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editWatchProductFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete watch products action creators
export const bulkDeleteWatchProductsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteWatchProductsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteWatchProductsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteWatchProductsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteWatchProducts = watchProducts => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, watchProducts);
    };
};

// Delete watch product action creators
export const deleteWatchProductInit = () => {
    return crudActions.deleteInit();
};
export const deleteWatchProductStart = () => {
    return crudActions.deleteStart();
};
export const deleteWatchProductSuccess = deletedWatchProduct => {
    return crudActions.deleteSuccess(deletedWatchProduct);
};
export const deleteWatchProductFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteWatchProduct = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

// custom functions
export const fetchGrades = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: grade.GradeID, displayValue: `${grade.InternationalGrading} (${grade.Condition})` });
                }
                return grades;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const fetchGradingCategories = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grading_category/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const gradingCategories = [];
                for (var category of res.data.result.data) {
                    gradingCategories.push({ value: category.GradingCategoryID, displayValue: category.Product });
                }
                return gradingCategories;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const fetchTypicalProblems = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/typical_problems/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                let typicalProblems = [];
                for (var tp of res.data.result.data) {
                    if (tp.GradingCategory && tp.GradingCategory.Product) {
                        tp.GradingCategory.Product = tp.GradingCategory.Product.replace('unknown', 'All');
                    }
                    typicalProblems.push({ value: tp.TypicalProblemID, label: `${tp.LongName}${tp.GradingCategory ? ` - ${tp.GradingCategory.Product}` : ''}` });
                }
                return typicalProblems;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const downloadRawData = (ProductID, customerID) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        return fetch(`${config.backend_domain}:${config.backend_port}/products/get_raw_data?ProductID=${ProductID}&ActiveCustomerID=${customerID.ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            let fileName = `${moment().valueOf()}.txt`;
            response.headers.forEach((value, key) => {
                if (key === 'filename') {
                    fileName = value;
                }
            });
            if (response.status === 200) {
                return { status: 200, blob: await response.blob(), fileName: fileName }
            }
            try {
                let responseText = await response.text();
                responseText = JSON.parse(responseText);
                return {
                    status: response.status,
                    message: responseText.message
                }
            } catch (error) {
                return {
                    status: response.status,
                    message: null
                }
            }
        });
    }
};

export const createFromExternal = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/unpairedPalette/createFromExternal', data);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Palette created."}`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create palette."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            return false;
        }
    };
}

export const generateReport = (watchProduct, translations) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            watchProduct['SocketID'] = socket.id.split('#')[1];
            dispatch({ type: 'START_GENERATE' });
            snackActions.snackBar({
                message: translations['generating_report'] || `Erasure report generation started.`,
                options: {
                    variant: 'success'
                }
            });

            let res = await rest.post('report/generate', watchProduct);
            if (res.data && res.data.succeeded) {
                const redisTopic = res.data.result.data.RedisTopic;
                socket.once(redisTopic, async msg => {
                    const { Message, Status, ErasureReportID } = msg;
                    if (Status !== 'generated') {
                        snackActions.snackBar({
                            message: Message ?? (translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`),
                            options: {
                                variant: 'error'
                            }
                        });
                        dispatch({ type: 'FINISH_GENERATE' });
                        return false;
                    }
                    const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${watchProduct.ActiveCustomerID}`;
                    await download(objUrl);
                    snackActions.snackBar({
                        message: translations['generating_report'] || `Erasure report generation finished.`,
                        options: {
                            variant: 'success'
                        }
                    });
                    dispatch({ type: 'FINISH_GENERATE' });

                });
            } else {
                snackActions.snackBar({
                    message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const fetchPrinters = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/printers/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const printers = [];
                for (var printer of res.data.result.data) {
                    printers.push({ value: printer.PrinterID, displayValue: `${printer.Name} (${printer.PrinterType} / ${printer.ConnectionType})` });
                }
                return printers;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

// custom functions
export const isPrintedLabel = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/is-printed', data);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Successfully printed label."}`,
                    options: {
                        variant: 'success'
                    }
                });

                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot print label."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            return false;
        }
    };
}

export const printLabel = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/print_label', data);
            if (res.data && res.data.succeeded) {
                return res.data.status === 200;
            }
            else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
}

export const fetchOrders = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('palettes/order/list', { ...id, listAll: true, formatForWEBUI: true, productChangePalette: true });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            return response ? response : [];
        } catch (error) {
            return [];
        }
    }
}

export const moveToAnotherPalette = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/watchProduct/change_palette', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot change palette."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const bulkPrintLabels = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/watchProduct/bulk_print_label', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot print label."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        }
        catch (error) {
            return [];
        }
    }
}

export const bulkGenerateReports = (data, translations) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            data['SocketID'] = socket.id.split('#')[1];;
            let res = await rest.post('products/watchProduct/bulk_generate_report', data);
            if (res.data.status === 200) {
                for (const redisTopic of res.data.result.data.RedisTopics) {
                    socket.once(`${redisTopic}|0`, () => {
                        snackActions.snackBar({
                            message: translations['generate_report_start'] || `Erasure report starting.`,
                            options: {
                                variant: 'info'
                            }
                        });

                        socket.once(`${redisTopic}|2`, async msg => {
                            if (msg.Message.name === 'ERROR') {
                                snackActions.snackBar({
                                    message: msg.Message?.data?.message ?? (translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`),
                                    options: {
                                        variant: 'error'
                                    }
                                });
                                return false;
                            }
                            const reportID = msg.Message.data;
                            const filename = msg.Message.name;

                            let file = await dispatch(actionDownload.downloadErasure(reportID, data.ActiveCustomerID, filename, translations));
                            if (file) {
                                downloadFile(file, filename);
                            }
                        });
                    });
                }
                return true;
            }
            else {
                snackActions.snackBar({
                    message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}

export const unpairExternal = externalID => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/watchProduct/unpair', { ProductExternalInfoID: externalID.data, ActiveCustomerID: externalID.ActiveCustomerID });
            return res.data.status === 200;
        } catch (error) {
            return false;
        }
    };
}

export const unpairBulkExternalWatch = externalIDs => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/watchProduct/bulk_unpair', { ProductExternalInfoIDs: externalIDs.data, ActiveCustomerID: externalIDs.ActiveCustomerID });
            return res.data.status === 200;
        } catch (error) {
            return false;
        }
    };
}

export const setWatchProduct = (data) => {
    return ({
        type: 'HANDLE_WATCH_PRODUCT',
        productWatch: data
    });
}

export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}

export const galleryTrue = () => {
    return ({
        type: 'GALLERY_OPEN_WATCH',
    });
}

